const footerNav = [
  {
    title: "追踪板块",
    links: [
      { href: "#timeline", label: "最新进展" },
      { href: "#series", label: "热门连续剧" },
      { href: "#reversal", label: "后续反转" },
      { href: "#official", label: "官方回应" },
    ],
  },
  {
    title: "发现更多",
    links: [
      { href: "#rank", label: "新瓜榜" },
      { href: "#faq", label: "常见问题" },
      { href: "#about", label: "关于我们" },
      { href: "#contact", label: "联系与投稿" },
    ],
  },
];

const footerTags = ["雨夜直播断线", "剧组合约罗生门", "新歌抄袭疑云", "旧照翻红风波", "代言争夺战"];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-100 border-t border-secondary-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2">
              <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500">
                <i className="ri-water-flash-fill text-xl text-background-50" />
              </span>
              <span className="font-label text-2xl text-foreground-950">瓜田速报</span>
            </div>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
              网爆吃瓜连续剧追踪站。把零散热议整理成完整剧情线，跟进后续反转、最新进展、当事人发声与官方回应，
              新瓜出现第一时间同步。
            </p>
            <a
              href="#contact"
              className="mt-5 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-megaphone-line" />
              提供新瓜线索
            </a>
          </div>

          {footerNav.map((column) => (
            <nav key={column.title} aria-label={column.title}>
              <h4 className="font-heading text-base font-bold text-foreground-950">{column.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-700 hover:text-primary-700 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-secondary-200">
          <p className="text-sm font-medium text-foreground-800">正在追踪的事件线</p>
          <div className="mt-3 flex flex-wrap gap-2">
            {footerTags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1 rounded-full text-xs bg-background-50 text-foreground-700 border border-secondary-200"
              >
                #{tag}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © {year} 瓜田速报 · 站内内容为公开信息整理与脉络复盘，仅供交流参考
          </p>
          <p className="text-xs text-foreground-600">
            线索与更正：kefu@guatian-suhao.example.com
          </p>
        </div>
      </div>
    </footer>
  );
}